const BaseView = require('../../../components/accordion-list/content');

module.exports = BaseView.extend({
  initialize: function () {
    _.bindAll(this, 'thumbnailClickEvent');
    BaseView.prototype.initialize.call(this);
  },

  thumbnailClickEvent: function () {
  },

  initDataLoading: function () {
    this.end && this.end();
    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
  },

  initAuthenticatedDataLoading: function () {
    this.authenticated = true;
    BaseView.prototype.initDataLoading.call(this);
  },

  authenticate: function () {
    const deferred = $.Deferred();
    this.authenticated && deferred.resolve();
    this.authenticated || _.bind(doLogin, this)();

    return deferred.promise();

    function doLogin () {
      const scope = this.scope;
      const onLogin = _.bind(onFacebookLogin, this);
      window.loadFacebookLibrary(function () {
        FB.login(onLogin, { scope });
      });
    }

    function onFacebookLogin (response) {
      if (response.authResponse) {
        deferred.resolve();
        this.initAuthenticatedDataLoading();
      } else {
        this.trigger('no_access');
        deferred.reject();
        INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
      }
    }
  },

  loadData: function (repeat, end) {
    this.end = end;
    this.repeat = repeat;

    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
    INKIVE.Helpers.sendCmd(
      INKIVE.C.BASE_URL + this.apiCall,
      this.getParams(),
      this.onMoreData
    );
  },

  getParams: function () {
    return {
      width: 107,
      height: 73,
      fb_token: this.tool.facebookToken || FB.getAccessToken()
    };
  },

  onMoreData: function (result) {
    INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
    // result is a json string
    if (result && result !== '[]') {
      this.end();
      this.appendThumbnails(result);
    } else {
      this.authenticated = false;
      BaseView.prototype.closeView.call(this);
      this.$el.prev('.btn').click();
    }
  },

  appendThumbnails: function (data) {
    const $thumbnailWrapper = this.$el.find('.thumbnail-wrapper');

    _.each(this.extractData(data), function (item) {
      const onClick = _.partial(this.thumbnailClickEvent, item.id);
      const $thumbGroup = new INKIVE.ThumbGroupImage($.extend(item, {
        tooltip: item.name,
        thumb: item.src,
        onItemLoad: function (thumb) {
          $(thumb).on('click', onClick);
        }
      }));

      $thumbGroup.appendTo($thumbnailWrapper);
    }, this);
  },

  masonryReload: function () {
    const hasOpenSubView = this.$el.is('.out');

    if (hasOpenSubView) {
      for (const key in this.views) {
        this.views[key].masonryReload();
      }
    } else {
      BaseView.prototype.masonryReload.call(this);
    }

    this.$el.closest('.add.antiscroll-wrap')
      .children('.antiscroll-scrollbar')
      .hide();
  },

  getScrollHeight: function ($target) {
    const marginTop = 65;
    return $target.closest('.add').height() - marginTop;
  },

  extractData: function (data) {
    return $.parseJSON(data);
  }
});
